'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'spinner';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f110';
var svgPathData = 'M256 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0 352a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM32 256a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm64 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm368-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM97.6 414.4a16 16 0 1 1 22.6-22.6 16 16 0 1 1 -22.6 22.6zm45.3-45.3A48 48 0 1 0 75 437 48 48 0 1 0 142.9 369.1zM120.2 97.6a16 16 0 1 1 -22.6 22.6 16 16 0 1 1 22.6-22.6zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9zM391.8 391.8a16 16 0 1 1 22.6 22.6 16 16 0 1 1 -22.6-22.6zM437 437A48 48 0 1 0 369.1 369.1 48 48 0 1 0 437 437z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSpinner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;